import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import dayjs from 'dayjs';
import SoftBadge from 'components/common/SoftBadge';

const COMPLETED_PROGRESS = 3;
const MS_PER_HOUR = 60 * 60 * 1000;
const REFRESH_INTERVAL_MS = 60 * 1000;

const formatDaysHours = totalHours => {
  const days = Math.floor(totalHours / 24);
  const hours = totalHours % 24;
  return days > 0 ? `${days}d ${hours}h` : `${hours}h`;
};

const TargetDateCountdown = ({ targetDate, progress }) => {
  const [now, setNow] = useState(() => Date.now());

  useEffect(() => {
    const timer = setInterval(() => setNow(Date.now()), REFRESH_INTERVAL_MS);
    return () => clearInterval(timer);
  }, []);

  if (!targetDate || progress === COMPLETED_PROGRESS) return null;

  const dueAt = dayjs(targetDate).endOf('day').valueOf();
  const remainingMs = dueAt - now;
  const isOverdue = remainingMs < 0;
  const wholeHours = Math.floor(Math.abs(remainingMs) / MS_PER_HOUR);

  return (
    <SoftBadge
      bg={isOverdue ? 'danger' : 'secondary'}
      className="fs--2 mt-1"
    >
      {isOverdue
        ? `Overdue ${formatDaysHours(wholeHours)}`
        : `${formatDaysHours(wholeHours)} left`}
    </SoftBadge>
  );
};

TargetDateCountdown.propTypes = {
  targetDate: PropTypes.string,
  progress: PropTypes.number
};

export default TargetDateCountdown;
